<template>
	<v-dialog persistent @click:outside="closeDialog()" :value="dialog" max-width="450" scrollable >
		<v-card >
			<v-card-title>
				{{ $vuetify.lang.t('$vuetify.views.chat.addUsers') }}
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<div class="mt-2"></div>
				<v-text-field
					v-model="fields.search"
					@input="onInput"
					outlined
					dense
					prepend-inner-icon="mdi-magnify"
					hide-details
					clearable
				/>
				<div v-if="loading">
					<template v-for="i in 10">
						<v-skeleton-loader
							:key="i"
							type="list-item-avatar-two-line"
						></v-skeleton-loader>
					</template>
				</div>
				<v-list v-else>
					<v-list-item-group
						v-model="fields.users"
						multiple
					>
						<template v-for="(item, i) in searchedUsers">
						<v-divider
							v-if="!item"
							:key="`divider-${i}`"
						></v-divider>

						<v-list-item
							v-else
							:key="`item-${i}`"
							:value="item"
							:disabled="userExists(item)"
							active-class="text--accent"
						>
							<template v-slot:default="{ active }">
							<v-list-item-content>
								<div class="d-flex flex-row align-items-center">
									<div class="mr-1">
										<avatar :user="item" class="mr-2" />
									</div>
										{{ item.name || item.email }}
								</div>


							</v-list-item-content>

							<v-list-item-action>
								<v-icon v-if="userExists(item)" color="accent">mdi-checkbox-marked</v-icon>
								<v-checkbox
									v-else
									:input-value="active"
									color="accent"
								></v-checkbox>
							</v-list-item-action>
							</template>
						</v-list-item>
						</template>
					</v-list-item-group>
				</v-list>
			</v-card-text>
			<v-card-actions class="py-3">
				<v-btn @click="closeDialog()" class="ml-auto"> {{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn @click="submit()" :loading="saving" color="primary"> <v-icon >mdi-check</v-icon> {{ $vuetify.lang.t('$vuetify.add') }} </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import Avatar from '@/components/Avatar';
import _ from 'lodash';
export default {
	props: {
		chat: {
			type: Object,
			required: true
		}
	},
	components: {
		Avatar
	},
	data() {
		return {
			dialog: false,
			saving: false,
			fields: {
				search: '',
				users: []
			},
			users: [],
			loading: false
		}
	},
	computed: {
		searchedUsers() {
			if(this.fields.search) {
				return _.orderBy(this.users.filter(x => {
					return x.name.toLowerCase().search(this.fields.search.toLowerCase()) != -1
					|| x.email.toLowerCase().search(this.fields.search.toLowerCase()) != -1
				}), 'name');
			}
			return _.orderBy(this.users,'name');
		}
	},
	methods: {
		onInput() {

		},
		userExists(user) {
			if(this.chat.users.findIndex(x => x.id == user.id) != -1) {
				return true;
			}
			return false;
		},
		async searchUsers() {
			this.loading = true;
				let data = await this.$store.dispatch('user/searchUser', {
					name: this.search
				});
				if(data.data) {
					this.users = data.data;
				}
				else {
					this.users = []
				}
			this.loading = false;
		},
		closeDialog() {
			this.dialog = false;
			this.fields.users = [];
			this.$emit('close');
		},
		async submit() {
			let ids = this.fields.users.map(function(user) { return user.id; });
			this.saving = true;
			const res = await this.$store.dispatch('chat/inviteUsers', {
						chat_room_id: this.chat.id,
						user_ids: ids
					});
			if(res.success) {
				this.$snackbar.success("Pomyślnie dodano użytkownika");
				this.$emit('added', this.fields);
				this.closeDialog();
			}
			this.saving = false;
		},
		showDialog() {
			this.searchUsers();
			this.fields.users = [];
			this.dialog = true;
		}
	}
}
</script>
